var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-stepped',{ref:"page",attrs:{"title":_vm.title,"steps":_vm.steps,"model":_vm.model,"fetch-endpoint":null,"save-endpoint":_vm.saveEndpoint,"after-save":_vm.afterSave,"rules":_vm.rules,"breadcrumbs":_vm.breadcrumbs,"icon":_vm.icon,"description":_vm.description}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09b3b075","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/integrations/pages/IntegrationCreateSteppedPage.vue
// module id = null
// module chunks = 